module.exports = __webpack_public_path__ + "img/base_outside_bw.0de97b8e.png";